import { styled } from "@mui/material";
import { useCheckoutUI } from "../../CheckoutUIProvider";
import { MobileCartProduct } from "./MobileCartProduct";

const CartContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: "24px",
  width: "100%",
});

export const MobileCart = () => {
  const [state] = useCheckoutUI();

  const { checkoutIntent } = state.context;

  const cartItems = checkoutIntent?.items;

  if (!cartItems?.length) {
    return null;
  }

  return (
    <CartContainer>
      {cartItems.map((item) => (
        // @ts-ignore
        <MobileCartProduct key={item.stacklineSku} product={item} />
      ))}
    </CartContainer>
  );
};
